import { BaseParameters } from "../interfaces/tanstackTypes"

export const EMPTY_QUERY_PARAM = "None"
export const emptyParams: BaseParameters = {}